"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageSelector = exports.LanguageSelectorComponent = exports.LanguageSelectorItemComponent = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const I18n_1 = require("../../../i18n/I18n");
function LanguageSelectorItemComponent(props) {
    return jsx_runtime_1.jsx("option", Object.assign({ value: `${props.children}` }, props), void 0);
}
exports.LanguageSelectorItemComponent = LanguageSelectorItemComponent;
function LanguageSelectorComponent({ current, languages, onSelectLanguage, ItemComponent = LanguageSelectorItemComponent, }) {
    const handleOnChange = (event) => {
        const language = event.target.value;
        onSelectLanguage(language);
    };
    return (jsx_runtime_1.jsxs("select", Object.assign({ value: current, onChange: handleOnChange }, { children: [jsx_runtime_1.jsx(ItemComponent, { children: current }, void 0),
            languages.map((language) => (jsx_runtime_1.jsx(ItemComponent, { children: language }, language)))] }), void 0));
}
exports.LanguageSelectorComponent = LanguageSelectorComponent;
function LanguageSelector(_a) {
    var { Component = LanguageSelectorComponent, onSelectLanguage } = _a, props = tslib_1.__rest(_a, ["Component", "onSelectLanguage"]);
    const { i18n } = I18n_1.useTranslation();
    const i18nLanguage = i18n.language;
    const supportedLngs = i18n.options.supportedLngs;
    const [current, setLanguage] = react_1.useState();
    const [languages, setLanguages] = react_1.useState([]);
    react_1.useEffect(() => {
        if (i18nLanguage !== current) {
            setLanguage(i18nLanguage);
            setLanguages(supportedLngs ? supportedLngs.filter((lng) => ![current, "cimode"].includes(lng)) : []);
        }
    }, [i18nLanguage, supportedLngs]);
    const handleOnSelectLanguage = (language) => {
        setLanguage(language);
        i18n.changeLanguage(language);
        onSelectLanguage && onSelectLanguage(language);
    };
    return (jsx_runtime_1.jsx(Component, Object.assign({ languages: languages, current: current, onSelectLanguage: handleOnSelectLanguage }, props), void 0));
}
exports.LanguageSelector = LanguageSelector;
//# sourceMappingURL=LanguageSelector.js.map